import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "申请试用", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "如需申请试用，请填写表单信息，我们将在第一时间与您联系", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    class: "application-exp",
    width: "620px",
    centered: "",
    footer: null,
    visible: _ctx.visible,
    onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref: "formRef",
        model: _ctx.formState,
        rules: _ctx.rules,
        onFinish: _ctx._handleFinish
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            ref: "companyName",
            "has-feedback": "",
            label: "组织名称",
            name: "companyName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                placeholder: "请输入组织名称",
                value: _ctx.formState.companyName,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.companyName) = $event))
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "userName",
            "has-feedback": "",
            label: "姓名",
            name: "userName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                placeholder: "请输入姓名",
                value: _ctx.formState.userName,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.userName) = $event))
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "phone",
            "has-feedback": "",
            label: "手机号",
            name: "phone"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                placeholder: "请输入手机号码",
                value: _ctx.formState.phone,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.phone) = $event))
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "email",
            "has-feedback": "",
            label: "邮箱",
            name: "email"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                placeholder: "请输入邮箱",
                value: _ctx.formState.email,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.email) = $event))
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "description",
            "has-feedback": "",
            label: "需求简述",
            name: "description"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_textarea, {
                placeholder: "请简单描述您的需求、用途等",
                value: _ctx.formState.description,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.description) = $event))
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                "html-type": "submit",
                class: "ok"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("提交申请")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules", "onFinish"])
    ]),
    _: 1
  }, 8, ["visible"]))
}